import i18n from '../i18n/i18n';

const createFeed = {
  display: true,
  title: i18n.t('createFeed.title'),
  template: 'CreateFeed',
  customClass: "feed-drawer",
  forAdmin: false,
  method: (instance) => {
    instance.drawer = true;
  },
};

/*
  Global settings of the application header.
  They contain:
  - title,
  - subTitle,
  - count,
  - roles display (admin, manager, operator),
  - getters for interacting with the store,
  - functions that can be called in the application header (for example, when you click on the "Create feed" button)
  use i18n locale
  see http://kazupon.github.io/vue-i18n/started.html for details
*/

export default [
  {
    name: "home",
    title:{
      static: true,
      data: i18n.t('header.home.title')
    },
    subtitle: i18n.t('header.home.subtitle'),
    count: {
      display: true,
      getter: "feedsCount"
    },
    action: createFeed,
  },
  {
    name: "users",
    title: {
      static: true,
      data: i18n.t('header.users.title')
    },
    subtitle: i18n.t('header.users.subtitle'),
    count: {
      display: true,
      getter: "usersCount"
    },
    action: {
      display: true,
      forAdmin: true,
      title: i18n.t('header.users.action.title'),
      template: 'AddUser',
      customClass: "user-drawer",
      method: (instance) => {
        instance.drawer = true;
      },
    },
  },
  {
    name: "extUsers",
    title: {
      static: true,
      data: i18n.t('header.extUsers.title')
    },
    subtitle: i18n.t('header.extUsers.subtitle'),
    count: {
      display: true,
      getter: "extUsersCount"
    },
    action: {
      display: false,
    },
  },
  {
    name: "iaoGuides",
    title: {
      static: true,
      data: i18n.t('header.iaoGuides.title')
    },
    count: {
      display: false,
    },
    action: {
      display: false,
    },
  },
  {
    name: "guides",
    title: {
      static: true,
      data: i18n.t('header.guides.title')
    },
    subtitle: i18n.t('header.guides.title'),
    count: {
      display: false
    },
    action: {
      forAdmin: true,
      display: false
    },
  },
  {
    name: "events",
    title: {
      static: true,
      data: i18n.t('header.events.title')
    },
    subtitle: i18n.t('header.events.title'),
    count: {
      display: false
    },
    action: {
      forAdmin: true,
      display: false
    },
  },
  {
    name: "themes",
    title: {
      static: true,
      data: i18n.t('header.themes.title')
    },
    subtitle: i18n.t('header.themes.title'),
    count: {
      display: false
    },
    action: {
      forAdmin: true,
      display: false
    },
  },
  {
  name: "directory",
    title: {
      static: true,
      data: i18n.t('header.directory.title')
    },
    subtitle: i18n.t('header.directory.title'),
    count: {
      display: false
    },
    action: {
      forAdmin: true,
      display: false
    },
  },
  {
    name: "feedAnalytics",
    title: {
      static: false,
      getter: "feedTitle",
      default: i18n.t('header.feedAnalytics.title.default')
    },
    subtitle: i18n.t('header.feedAnalytics.subtitle'),
    count: {
      display: false
    },
    action: {
      forAdmin: true,
      display: false
    },
  },
  {
    name: "feedSettings",
    title: {
      static: false,
      getter: "feedTitle",
      default: i18n.t('header.feedSettings.title.default')
    },
    subtitle: i18n.t('header.feedSettings.subtitle'),
    count: {
      display: false
    },
    action: {
      display: false
    },
  },
  {
    name: "feedAnalyticsEdit",
    title: {
      static: false,
      getter: "feedTitle",
      default: i18n.t('header.feedAnalyticsEdit.title.default')
    },
    subtitle: i18n.t('header.feedAnalyticsEdit.subtitle'),
    count: {
      display: false
    },
    action: {
      forAdmin: true,
      display: false
    },
  },
  {
    name: "feedAuditEdit",
    title: {
      static: false,
      getter: "feedTitle",
      default: i18n.t('header.feedAuditEdit.title.default')
    },
    subtitle: i18n.t('header.feedAuditEdit.subtitle'),
    count: {
      display: false
    },
    action: {
      forAdmin: true,
      display: false
    },
  }
];
